import React from 'react';
import { meldeFehler } from '../lib/fehlerMelder';

// Fängt Renderfehler ab, damit statt einer weißen Seite ein Hinweis erscheint.
// Achtung: Fehler in Event-Handlern (z. B. beim Klick auf einen Knopf) erreichen
// eine ErrorBoundary grundsätzlich nicht — die deckt der globale error-Listener ab.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { fehler: null, details: '' };
  }

  static getDerivedStateFromError(fehler) {
    return { fehler };
  }

  componentDidCatch(fehler, info) {
    this.setState({ details: info?.componentStack || '' });
    meldeFehler({
      message: fehler?.message || String(fehler),
      stack: fehler?.stack || '',
      componentStack: info?.componentStack || '',
    });
  }

  render() {
    if (!this.state.fehler) return this.props.children;
    const text = [this.state.fehler?.message || String(this.state.fehler), this.state.details]
      .filter(Boolean).join('\n\n');
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6" data-testid="error-boundary">
        <div className="max-w-xl w-full bg-white border border-slate-200 rounded-xl p-8 shadow-sm">
          <h1 className="text-2xl font-semibold text-slate-900">Hier ist etwas schiefgelaufen</h1>
          <p className="text-base text-slate-600 mt-3">
            Ihre Eingaben sind nicht verloren gegangen, solange Sie sie gespeichert haben.
            Gehen Sie am besten zurück zur Startseite und versuchen es erneut.
            Wenn es wieder passiert, geben Sie bitte dem Backoffice die untenstehende Meldung durch.
          </p>
          <div className="flex flex-col sm:flex-row gap-2 mt-6">
            <button
              type="button"
              onClick={() => { window.location.href = '/'; }}
              className="px-4 py-2 rounded-md bg-blue-800 text-white hover:bg-blue-900 transition-colors"
              data-testid="error-boundary-home-button"
            >
              Zur Startseite
            </button>
            <button
              type="button"
              onClick={() => { window.location.reload(); }}
              className="px-4 py-2 rounded-md border border-slate-300 text-slate-700 hover:bg-slate-50 transition-colors"
              data-testid="error-boundary-reload-button"
            >
              Seite neu laden
            </button>
          </div>
          <details className="mt-6" data-testid="error-boundary-details">
            <summary className="text-sm text-slate-500 cursor-pointer">Technische Meldung anzeigen</summary>
            <pre className="mt-2 text-xs bg-slate-900 text-slate-100 rounded-md p-3 overflow-auto max-h-64 whitespace-pre-wrap">
              {text}
            </pre>
          </details>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
